import { render, staticRenderFns } from "./SeatingItem.vue?vue&type=template&id=b00ea97c&"
import script from "./SeatingItem.vue?vue&type=script&lang=js&"
export * from "./SeatingItem.vue?vue&type=script&lang=js&"
import style0 from "./SeatingItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports